import { Component, Input, OnInit, AfterViewInit, ViewChild, ViewChildren, QueryList, ElementRef, TemplateRef } from '@angular/core';

const PAGE_HEIGHT = 1123; // px, A4 at 96dpi

@Component({
  selector: 'app-template3',
  templateUrl: './template3.component.html',
  styleUrls: ['./template3.component.scss']
})
export class Template3Component implements OnInit {
  @Input() data: any;
  @Input() isThumbnail: boolean = false;

  @ViewChild('measureContainer') measureContainer!: ElementRef;
  @ViewChildren('sectionRefs', { read: ElementRef }) sectionRefs!: QueryList<ElementRef>;

  allSections: any[] = [];
  pages: any[][] = [];

  ngOnInit(): void {
  }
}
